module.exports = "/images/pagseguro.png?2bfd03acf26942daf7eb96de6422688c";